const quickStartGuideLinks = {
  ja: "https://docs.amethy.st/ja/quickstart/",
  en: "https://docs.amethy.st/quickstart/",
} as const;

export function getQuickStartGuideUrl(locale: string | null | undefined) {
  return locale === "ja" ? quickStartGuideLinks.ja : quickStartGuideLinks.en;
}
